export function removeAuth() {
  return new Promise((resolve) => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("tokenSetAt");
    localStorage.removeItem("company");
    return resolve();
  });
}

export function setAuth({ token, email, company }) {
  return new Promise((resolve) => {
    localStorage.setItem("token", token);
    localStorage.setItem("email", email);
    localStorage.setItem("company", company ? company.id : undefined);
    localStorage.setItem("tokenSetAt", new Date());
    return resolve({
      token,
      email,
      company,
    });
  });
}

export function setToken(token) {
  return new Promise((resolve) => {
    localStorage.setItem("token", token);
    localStorage.setItem("tokenSetAt", new Date());
    return resolve({
      token,
    });
  });
}

export function setCompany({ company }) {
  return new Promise((resolve) => {
    localStorage.setItem("company", company?.id);
    return resolve({
      company,
    });
  });
}
export function getAuth() {
  return new Promise((resolve) => {
    const auth = {
      token: localStorage.getItem("token"),
      email: localStorage.getItem("email"),
      tokenSetAt: localStorage.getItem("tokenSetAt"),
      company: localStorage.getItem("company"),
    };
    return resolve(auth);
  });
}
